import { LOCAL_STORAGE_KEYS } from "../utils/constants";
import { invokeApi } from "../bl_libs/invokeApi";
import { use_e2ee } from "../utils/utils";

const getToken = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));

// ─── Feature catalog (read-only — features are defined in backend constants) ──

/**
 * List the platform feature catalog (FEATURE_CATALOG from the backend).
 * Response: { data: { features: [{ feature_key, label, description, default_config }] } }
 */
export const listFeaturesService = () => {
    return invokeApi({
        path: '/admin/features/list',
        method: 'GET',
        headers: { Authorization: `Bearer ${getToken()}` },
    }, use_e2ee());
};

// ─── Per-insider feature-access overrides (admin force-enable/disable) ────────

export const getInsiderFeatureAccessService = (dq_insider_id) => {
    return invokeApi({
        path: '/admin/pac/insider/get_feature',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: { dq_insider_id },
    }, use_e2ee());
};

/**
 * overrides: { [feature_key]: { enabled: boolean, config?: object } }
 */
export const setInsiderFeatureOverridesService = (dq_insider_id, overrides) => {
    return invokeApi({
        path: '/admin/pac/insider/set_feature',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: { dq_insider_id, overrides },
    }, use_e2ee());
};

export const removeInsiderFeatureOverrideService = (dq_insider_id, feature_key) => {
    return invokeApi({
        path: '/admin/pac/insider/remove_feature_override',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: { dq_insider_id, feature_key },
    }, use_e2ee());
};

export const resetInsiderFeatureOverridesService = (dq_insider_id) => {
    return invokeApi({
        path: '/admin/pac/insider/reset_feature',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: { dq_insider_id },
    }, use_e2ee());
};
